/********************************** Modals ********************/

// open modal
document.querySelectorAll(`[open-modal]`).forEach(function (element) {
    element.addEventListener("click", function () {
        let id = this.getAttribute("open-modal");
        if (document.querySelector(`#modal-${id}`)) {
            document.querySelector("body").classList.add("noScroll");
            document.querySelector(`#modal-${id}`).classList.add("active");
        }
    });
});

// close modal - backdrop
document.querySelectorAll(".modal").forEach(function (element) {
    element.addEventListener("click", function (e) {
        if (e.target === this) {
            document.querySelector("body").classList.remove("noScroll");
            this.classList.remove("active");
        }
    });
});

// close modal - exit button
document.querySelectorAll(".modalExit").forEach(function (element) {
    element.addEventListener("click", function () {
        document.querySelector("body").classList.remove("noScroll");
        this.closest(".modal").classList.remove("active");
    });
});


/************** Scrolling ****************/

// function to scroll to top
function scrollToTop() {
    window.scrollTo({
        top: window.innerWidth > 800 ? 200 : 800,
        behavior: "smooth"
    });
}

// scroll top
document.querySelectorAll(`[href="#scroll_top"]`).forEach(element => element.addEventListener("click", function (e) {
    e.preventDefault();
    scrollToTop();
}));

// scroll to reviews if stars are clicked
document.querySelectorAll(`[class^="productV"][class*="Yotpo"]`).forEach(element => element.addEventListener("click", function (e) {
    e.preventDefault();
    window.scrollTo({
        top: document.querySelector(".yotpo-widget-instance").offsetTop,
        behavior: "smooth"
    });
}));